//#region src/menu_item_sale_unit.ts
var MenuItemSaleUnit = /* @__PURE__ */ function(MenuItemSaleUnit) {
	MenuItemSaleUnit[MenuItemSaleUnit["Each"] = 0] = "Each";
	MenuItemSaleUnit[MenuItemSaleUnit["LB"] = 2] = "LB";
	MenuItemSaleUnit[MenuItemSaleUnit["OZ"] = 3] = "OZ";
	return MenuItemSaleUnit;
}(MenuItemSaleUnit || {});
//#endregion
export { MenuItemSaleUnit };

//# sourceMappingURL=menu_item_sale_unit.js.map